import { render } from "./RegisterStep2.vue?vue&type=template&id=219179a2&scoped=true"
import script from "./RegisterStep2.vue?vue&type=script&lang=js"
export * from "./RegisterStep2.vue?vue&type=script&lang=js"

import "./RegisterStep2.vue?vue&type=style&index=0&id=219179a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219179a2"]])

export default __exports__